export default __webpack_public_path__ + "static/media/25.f6cda6f8.png";